import { handleSelectProvider } from '../../modules/events/consultListeners';
import { appUrl, form, staffId } from '../../utils/variables';
import { t } from '../../utils/i18n';

export function loadProvidersDropdown(providers) {
    const wrapper = document.querySelector('.requestConsult__container .providersDropdown__wrapper');
    if (!wrapper) return;

    if(staffId) return;
    let list = document.querySelector(
        '.requestConsult__container .providersDropdown__wrapper .providers__select'
    );
    list.innerHTML = '';

    // "No preference" option (consult_allow_no_preference): rendered FIRST so the
    // visitor can submit without choosing a provider. An empty data-provider-id
    // is the sentinel — handleSelectProvider treats it as "no provider", so no
    // staff_id is sent and the consult comes in unassigned.
    if (form?.consult_allow_no_preference) {
        const defaultAvatar = `${appUrl}/assets/images/png/default-avatar.png`;
        list.insertAdjacentHTML(
            'beforeend',
            `
        <li class="providersDropdown__option providersDropdown__option--no-preference"
            data-provider-id=""
            data-provider="${t('no_preference')}"
            data-avt="${defaultAvatar}">

            <img src="${defaultAvatar}" />

            <div class="provider__info">
                <div>${t('no_preference')}</div>
            </div>
        </li>
        `
        );
    }

    if (providers.length <= 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
            <li>${t('no_providers_found')}</li>
        `
        );
    }

    for (const i of providers) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <li class="providersDropdown__option" 
            data-provider-id="${i.id}" 
            data-provider="${i.first_name + ' ' + i.last_name}"
            data-avt="${i?.photo ? i.photo : `${appUrl}/assets/images/png/default-avatar.png`}">
            
            <img src="${i?.photo ? i.photo : `${appUrl}/assets/images/png/default-avatar.png`}" />
            
            <div class="provider__info">
                <div>${i.first_name + ' ' + i.last_name}</div>
                ${i.title ? `<div class="providerDropdown__title">${i.title}</div>` : ''}
            </div>
        </li>
        `
        );
    }

    handleSelectProvider();
}
